const useToggleClass = () => {
  const addClass = (className: string, elementRef: any) => {
    const element = elementRef?.current;
    element?.classList.add(className);
  };

  const removeClass = (className: string, elementRef: any) => {
    const element = elementRef?.current;
    element?.classList.remove(className);
  };

  return {
    addClass,
    removeClass,
  };
};

export default useToggleClass;
